import { CartLinkedEntitlementsSchema, CartProductSchema, OperationType, ProductStatus } from '../../types';

export const isNewEntitlement = (entitlement: Partial<CartProductSchema | CartLinkedEntitlementsSchema>) => {
  return !!(
    entitlement?.operationType === OperationType.NEW || entitlement?.productStatuses?.includes(ProductStatus.NEW)
  );
};
